export enum CUSTOMER_TYPE_CHARGE {
  RENTER = "RENTER",
  PARTNER = "PARTNER",
}

export enum CHARGE_STATUS {
  RECEIVED = "RECEIVED",
  OVERDUE = "OVERDUE",
  PENDING = "PENDING",
  REMOVED = "REMOVED",
  RENEGOTIATED = "RENEGOTIATED",
  RENEGOTIATION = "RENEGOTIATION",
  NOT_CHARGED = "NOT_CHARGED",
  CONFIRMED = "CONFIRMED",
}

export enum CHARGE_TYPE {
  MAINTENANCE = "MAINTENANCE",
  PREPARATION = "PREPARATION",
  REPREPARATION = "REPREPARATION",
  CONTRACTFINE = "CONTRACTFINE",
  TRAFFICFINE = "TRAFFICFINE",
  MANAGEMENTTRAFFICFINES = "MANAGEMENTTRAFFICFINES",
  WEEKLY = "WEEKLY",
  RECISION = "RECISION",
  REACTIVATION = "REACTIVATION",
}

export interface ICharge {
  _id?: string;
  externalId?: string;
  dueDate: Date;
  paymentDate?: Date;
  chargeType: CHARGE_TYPE;
  clientType: CUSTOMER_TYPE_CHARGE;
  clientId: string;
  amount: number;
  status: CHARGE_STATUS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  details: any;
  createdAt: Date;
  updatedAt: Date;
}
